import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import CustomSnackbar from "../react_utils/CustomSnackbar";

export const MessagingContext = createContext();

export default function MessagingContextProvider({ children }) {
  const [snackbar, setSnackbar] = useState({
    open: false,
    msg: "",
    severity: "success",
    duration: 3000,
  });

  const showMessage = (msg, severity = "success", duration = 3000) => {
    setSnackbar((s) => ({ ...s, msg, open: true, severity, duration }));
  };

  return (
    <MessagingContext.Provider
      value={{
        showMessage,
      }}
    >
      {children}
      <CustomSnackbar
        message={snackbar.msg}
        duration={snackbar.duration}
        severity={snackbar.severity}
        open={snackbar.open}
        setIsOpen={(isOpen) => setSnackbar((s) => ({ ...s, open: isOpen }))}
      />
    </MessagingContext.Provider>
  );
}

MessagingContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
